export const COLORS = {
  BLUE: `rgba(${0x68},${0x9d},${0xf6},0.25)`,
  GREEN: `rgba(${0x79},${0xb6},${0x7d},0.25)`,
  RED: `rgba(${0xee},${0x69}, ${0x5d}, 0.25)`,
}
export const COLORS_ARRAY = Object.values(COLORS)
